import { Scale } from "../../../utils/Scale"

export class AddPos {

    static scientistX = () => Scale.width() - (Scale.width() * 0.6)
    static scientistY = () => Scale.height() - (Scale.height() * 0.88)

    static backToMuseumX = () => Scale.width() * 0.38
    static backToMuseumY = () => Scale.height() * 0.015

    static mentalX = () => Scale.width() - (Scale.width() * 0.95)
    static mentalY = () => Scale.height() - (Scale.height())

    static mentalClickHereX = () => AddPos.mentalX() + (Scale.width() * 0.13)
    static mentalClickHereY = () => AddPos.mentalY() + (Scale.height() * 0.36)

    static mentalTitleX = () => AddPos.mentalX() + (Scale.width() * 0.1)
    static mentalTitleY = () => AddPos.mentalY() + (Scale.height() * 0.18)

    static physicalX = () => Scale.width() - (Scale.width())
    static physicalY = () => Scale.height() - (Scale.height() * 0.49)

    static physicalClickHereX = () => AddPos.physicalX() + (Scale.width() * 0.18)
    static physicalClickHereY = () => AddPos.physicalY() + (Scale.height() * 0.23)

    static physicalTitleX = () => AddPos.physicalX() + (Scale.width() * 0.06)
    static physicalTitleY = () => AddPos.physicalY() + (Scale.height() * 0.29)

    static cravingsAndWithdrawalX = () => Scale.width() - (Scale.width() * 0.26)
    static cravingsAndWithdrawalY = () => Scale.height() - (Scale.height() * 0.62)

    static cravingsAndWithdrawalClickHereX = () => AddPos.cravingsAndWithdrawalX() + (Scale.width() * 0.09)
    static cravingsAndWithdrawalClickHereY = () => AddPos.cravingsAndWithdrawalY() + (Scale.height() * 0.25)

    static cravingsAndWithdrawalTitleX = () => AddPos.cravingsAndWithdrawalX() + (Scale.width() * 0.04)
    static cravingsAndWithdrawalTitleY = () => AddPos.cravingsAndWithdrawalY() + (Scale.height() * 0.2)

    static nicotineAndAddictionX = () => Scale.width() - (Scale.width() * 0.32)
    static nicotineAndAddictionY = () => Scale.height() - (Scale.height() * 0.97)

    static nicotineAndAddictionClickHereX = () => AddPos.nicotineAndAddictionX() + (Scale.width() * 0.2)
    static nicotineAndAddictionClickHereY = () => AddPos.nicotineAndAddictionY() + (Scale.height() * 0.08)

    static nicotineAndAddictionTitleX = () => AddPos.nicotineAndAddictionX() + (Scale.width() * -0.1)
    static nicotineAndAddictionTitleY = () => AddPos.nicotineAndAddictionY() + (Scale.height() * 0.01)

}
